"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _makeStyles.default)(function (theme) {
  return {
    form: _defineProperty({
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(1.5),
      width: "100%",
      "& input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active": {
        transition: "background-color 5000s ease-in-out 0s"
      }
    }, theme.breakpoints.up("sm"), {
      "& .mco-form-select": {
        flex: "0 0 calc(50% - ".concat(theme.spacing(0.75), "px)")
      },
      "& .mco-form-input:not(.mco-form-textarea):not(.mco-form-file)": {
        flex: "0 0 calc(50% - ".concat(theme.spacing(0.75), "px)")
      },
      "& .mco-form-date": {
        flex: "0 0 calc(50% - ".concat(theme.spacing(0.75), "px)")
      },
      "& .mco-form-multiple-checkbox": {
        flex: "0 0 calc(50% - ".concat(theme.spacing(0.75), "px)")
      }
    })
  };
});
var _default = styles;
exports.default = _default;